import { useQuery } from "@tanstack/react-query";
import { useAuth } from "@/context/AuthContext";
import { vendorApi } from "@/lib/api/vendor";
import type { ApplicationDetail } from "@/lib/api/review";

export const APPLICATION_DETAIL_QUERY_KEY = ["vendor", "applicationDetail"] as const;

export function useApplicationDetail() {
  const { user } = useAuth();
  const applicationId = user?.applicationId ?? null;

  return useQuery<ApplicationDetail>({
    queryKey: [...APPLICATION_DETAIL_QUERY_KEY, applicationId],
    queryFn: () => vendorApi.getApplicationDetail(applicationId!),
    enabled: !!applicationId,
  });
}
